import { useEffect, useState } from "react";

interface LoadingScreenAltProps {
  onLoadingComplete?: () => void;
  duration?: number;
}

export default function LoadingScreenAlt({ 
  onLoadingComplete, 
  duration = 2000 
}: LoadingScreenAltProps) {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(false);
      onLoadingComplete?.();
    }, duration);

    return () => clearTimeout(timeout);
  }, [duration, onLoadingComplete]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background">
      {/* Background animado */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: "1s" }} />
      </div>

      {/* Conteúdo central */}
      <div className="relative z-10 text-center flex flex-col items-center">
        {/* Spinner circular no topo */}
        <div className="mb-12 flex justify-center animate-fadeIn">
          <div className="relative w-32 h-32">
            <div className="absolute inset-0 border-4 border-muted/30 rounded-full" />
            <div className="absolute inset-0 border-4 border-transparent border-t-primary rounded-full animate-spin" />
          </div>
        </div>

        {/* Logo da marca */}
        <div className="mb-8 animate-fadeIn" style={{ animationDelay: "300ms" }}>
          <img 
            src="/logo.png" 
            alt="Coddar" 
            className="h-16 md:h-20 w-auto opacity-60 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500"
          />
        </div>

        {/* Loading text */}
        <div className="text-xl text-muted-foreground/80 animate-fadeIn tracking-widest" style={{ animationDelay: "600ms" }}>
          LOADING
          <span className="inline-flex ml-1">
            <span className="animate-bounce" style={{ animationDelay: "0ms" }}>.</span>
            <span className="animate-bounce" style={{ animationDelay: "150ms" }}>.</span>
            <span className="animate-bounce" style={{ animationDelay: "300ms" }}>.</span>
          </span>
        </div>
      </div>

      {/* Fade out effect */}
      <div 
        className="absolute inset-0 bg-background transition-opacity duration-500"
        style={{ 
          opacity: isVisible ? 0 : 1,
          pointerEvents: "none"
        }}
      />
    </div>
  );
}
